import {RepositoryFactory} from '@/api/factory/repositoryFactory'
const CrossVendor = RepositoryFactory.get('crossVendor')

const state = {}
const actions = {
  async callAction(_, {_pt, ...params}) {
    const res = await CrossVendor.callAction(params)
    if (_pt === 'number') return Number(res.data)
    return JSON.parse(res.data)
  },
}
const mutations = {}
const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
